// @see https://github.com/AS3Commons/as3commons-lang/blob/master/src/main/actionscript/org/as3commons/lang/StringBuffer.as

import { StringUtils } from './StringUtils';

export class StringBuffer {

		private _string:string[];

		/**
		 * Creates a new StringBuffer.
		 */
		public constructor(str:string = "") {
			this._string = (str ? [str] : []);
		}

		public append(value:any) : StringBuffer {
			this._string.push(value);
			return this;
		}

		public removeEnd(value:any):StringBuffer {
			this._string = [StringUtils.removeEnd(this.toString(), '' + value)];
			return this;
		}

		public toString():string {
			return this._string.join('');
		}
}
